
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Punetoanjamtaelloracabs() {



    const cardData =
    {
        keyword: 'Pune to Ajanta Ellora Cabs ',
        heading: 'Morya Cabs: Pune to Ajanta Ellora Cabs  ',
        headingDescription: 'Planning a trip from Pune to Ajanta Ellora? Morya Cabs offers comfortable, reliable, and affordable taxi services to ensure a smooth and enjoyable journey. These two iconic UNESCO World Heritage Sites, Ajanta and Ellora, are rich in history, culture, and architecture, and traveling there with Morya Cabs guarantees a stress-free experience. Whether you are visiting for a historical tour, a cultural experience, or simply exploring India’s heritage, our experienced drivers and well-maintained fleet ensure that you reach your destination safely and on time.',

        top: 'Top Places to Visit in Goa with Morya Cabs',

    "topPlaces": [
    {
        "title": "Ajanta Caves",
        "description": "Famous for its rock-cut Buddhist caves, Ajanta Caves are a masterpiece of ancient Indian architecture and painting. Explore the intricately carved sculptures and ancient frescoes that depict stories from Buddhist scriptures."
    },
    {
        "title": "Ellora Caves",
        "description": "Ellora Caves are a complex of 34 monasteries and temples, dedicated to Buddhism, Hinduism, and Jainism. The grand Kailasa temple, carved from a single rock, is a marvel and a must-see for history and architecture enthusiasts."
    },
    {
        "title": "Grishneshwar Temple",
        "description": "Located near Ellora, Grishneshwar Temple is one of the 12 Jyotirlingas of Lord Shiva. The temple’s beautiful architecture and religious significance make it an important stop for devotees and tourists alike."
    },
    {
        "title": "Daulatabad Fort",
        "description": "A historic hilltop fort, Daulatabad Fort is known for its strong defensive structures and historical relevance. Visit this ancient fort for its stunning views and to learn about its history."
    },
    {
        "title": "Bibi Ka Maqbara",
        "description": "Often referred to as the ‘Taj of the Deccan,’ Bibi Ka Maqbara is a beautiful mausoleum built by Azam Shah in memory of his mother. It offers picturesque views and is a prime example of Mughal architecture."
    },
    {
        "title": "Ellora Waterfalls",
        "description": "Located near Ellora, these waterfalls provide a serene spot for nature lovers to relax and enjoy the beauty of the surroundings. It's a great place to visit after exploring the caves."
    },
    {
        "title": "Lonar Lake",
        "description": "Though a bit farther from Ajanta and Ellora, Lonar Lake is a unique destination created by a meteorite impact. It’s a geological marvel and worth a visit for nature lovers and those interested in natural history."
    },
    {
        "title": "Aurangabad Caves",
        "description": "Aurangabad Caves, located near the city of Aurangabad, are another collection of ancient rock-cut Buddhist caves. These caves are less crowded compared to Ajanta and Ellora and offer a peaceful exploration experience."
    },
    {
        "title": "Panchakki",
        "description": "A historical watermill, Panchakki, was built during the Mughal era. It showcases ancient water management technology and is an interesting stop for history enthusiasts."
    },
    {
        "title": "Siddharth Garden and Zoo",
        "description": "Located in Aurangabad, Siddharth Garden is a beautiful park perfect for family outings. It also has a zoo where you can see a variety of wildlife."
    }
],



"services": [
    {
      "name": "Ajanta Ellora Caves Tour Package from Pune",
      "description": "Explore the ancient marvels of the Ajanta and Ellora Caves with our specially designed Ajanta Ellora Caves Tour Package from Pune. Our well-planned packages ensure a comfortable journey, guided tours of the caves, and visits to all significant spots. Whether you're a history enthusiast or simply looking to enjoy a peaceful getaway, this tour offers everything you need for an unforgettable experience."
    },
    {
      "name": "Ajanta Ellora Tour from Pimpri Chinchwad",
      "description": "For residents of Pimpri Chinchwad, we offer a customized Ajanta Ellora Tour from Pimpri Chinchwad, providing easy and convenient access to one of India’s most iconic historical landmarks. You can travel in style and comfort with Morya Cab’s well-maintained vehicles and experienced drivers."
    },
    {
      "name": "Trip to Ajanta Ellora Caves from Pune",
      "description": "Planning a Trip to Ajanta Ellora Caves from Pune? Morya Cab offers hassle-free cab services to take you on a journey to these UNESCO World Heritage Sites. Our cabs are equipped with the latest amenities, and our professional drivers ensure that you have a smooth and safe trip from Pune to Ajanta Ellora."
    },
    {
      "name": "Pune to Ajanta Ellora Cab Service",
      "description": "Our Pune to Ajanta Ellora Cab Service is available in a range of vehicles to suit your travel preferences. Whether you are traveling alone, with family, or in a group, we provide comfortable and convenient options for your journey. With affordable fares and excellent customer service, we guarantee a seamless trip to Ajanta Ellora."
    },
    {
      "name": "Pune to Ajanta Ellora Cab Booking",
      "description": "Booking your Pune to Ajanta Ellora Cab is easy with Morya Cab. You can book online, through our app, or by calling our customer service team. We offer a quick and simple process to ensure your travel plans are set up with minimal effort."
    },
    {
      "name": "Pune to Ajanta Ellora Cab Fare",
      "description": "The Pune to Ajanta Ellora Cab Fare varies based on the vehicle chosen and the type of service. We offer competitive and transparent pricing, ensuring that you get the best value for your money while enjoying a comfortable and safe ride to Ajanta Ellora."
    },
    {
      "name": "Pune to Ajanta Verul Cab Fare",
      "description": "We also offer Pune to Ajanta Verul Cab Fare for those looking to explore the Verul Caves near Ajanta. Our competitive rates ensure that you can enjoy this historic journey with ease and comfort. Contact us for the most affordable rates for your Ajanta Verul trip."
    },
    {
      "name": "Pune to Ajanta Ellora Innova Cab Fare",
      "description": "For those seeking extra comfort and space, our Pune to Ajanta Ellora Innova Cab Fare is perfect for families or groups. The Innova provides a comfortable ride with ample space for luggage, making it an ideal choice for long trips like this one."
    },
    {
      "name": "Pune to Ajanta Ellora Ertiga Cab",
      "description": "For a more compact yet comfortable ride, opt for our Pune to Ajanta Ellora Ertiga Cab. The Ertiga is a versatile vehicle that comfortably seats families or small groups, making it a great choice for your Ajanta Ellora trip. Book now for an affordable and enjoyable journey."
    },
    {
      "name": "Pune to Ajanta Ellora Tempo Traveller on Rent",
      "description": "Traveling with a larger group? Our Pune to Ajanta Ellora Tempo Traveller on Rent is the ideal option. With ample seating and comfort, the Tempo Traveller ensures that everyone enjoys the journey together. Perfect for family or group trips to Ajanta Ellora, it offers both comfort and convenience."
    },
    {
      "name": "Pune to Ajanta Ellora Sedan Cab Service",
      "description": "If you’re looking for a comfortable, yet budget-friendly option, our Pune to Ajanta Ellora Sedan Cab Service is the perfect solution. Whether you're traveling solo or with a small group, a sedan ensures a smooth and enjoyable ride to the caves while keeping costs low."
    },
    {
      "name": "Pune to Ajanta Ellora Mini Bus On Rent",
      "description": "For larger groups, we offer a Pune to Ajanta Ellora Mini Bus on Rent service. It’s ideal for group tours, school trips, or family reunions. With plenty of space and air-conditioned comfort, you can enjoy your journey without worrying about overcrowding or discomfort."
    },
    {
      "name": "Contact Information for Ajanta Ellora Tour Booking",
      "description": "To book your Pune to Ajanta Ellora trip or inquire about our services, contact Morya Cab at +91 9371304510. Whether you're looking for a sedan, an SUV, a luxury vehicle, or a large group transport option, we have the right cab for you. Experience a smooth and comfortable journey to one of India’s most fascinating cultural treasures!"
    }
  ],



  tableData: [
    ["Ajanta Ellora Caves Tour Package from Pune", "-Ajanta Ellora Tour from Pimpri Chinchwad"],
    ["Trip to Ajanta Ellora Caves from Pune", "-Pune to Ajanta Ellora Cab Service"],
    ["Pune to Ajanta Ellora Cab Booking", "-Pune to Ajanta Ellora Cab Fare"],
    ["Pune to Ajanta Verul Cab Fare", "-Pune to Ajanta Ellora Innova Cab Fare"],
    ["Pune to Ajanta Ellora Ertiga Cab", "-Pune to Ajanta Ellora Tempo Traveller on Rent"],
    ["Pune to Ajanta Ellora Sedan Cab Service", "-Pune to Ajanta Ellora Mini Bus on Rent"]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "Morya Cab ensures you reach Ajanta and Ellora on time, whether it's for a cultural exploration, historical visit, or religious journey. We understand the importance of timely arrivals and take care of every detail to make your trip smooth and stress-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We provide a range of vehicles, from sedans to SUVs, offering a comfortable, spacious ride. Whether you’re traveling alone, with family, or in a group, we ensure a pleasant and relaxing journey to these UNESCO World Heritage Sites."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are not only experienced in long-distance travel but are also familiar with the best routes to Ajanta and Ellora. Their professionalism ensures a safe and smooth ride, making your visit to these historic caves a memorable experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers affordable pricing for your Pune to Ajanta and Ellora trip, with no hidden charges. We provide a clear pricing structure upfront, so you know exactly what to expect."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our top priority. Our vehicles are equipped with the latest safety features such as airbags, seat belts, and GPS tracking, ensuring you have a secure and comfortable ride throughout your journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Morya Cab operates 24/7, allowing you to book your cab anytime, whether for an early morning trip or a late-night return. We’re always here to assist you with your travel needs."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking your Pune to Ajanta and Ellora cab is easy and hassle-free. You can book through our website, mobile app, or by contacting our customer service team, who will assist you with all your requirements."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're traveling to explore the caves or looking to extend your visit to nearby attractions, we offer customized travel packages tailored to your needs. Let us know your preferences, and we'll plan the perfect itinerary for you."
    }
]




        
















    }

    const faqData = [
        {
          question: "How can I book a Pune to Ajanta and Ellora cab with Morya Cab?",
          answer: "Booking is simple! You can book through our website, mobile app, or by contacting our customer service team, who will help you with the entire process."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, all of our drivers are experienced and familiar with the best routes to Ajanta and Ellora, ensuring a smooth, safe, and comfortable journey."
        },
        {
          question: "What types of vehicles are available for Pune to Ajanta and Ellora travel?",
          answer: "We offer a variety of vehicles, including sedans, SUVs, and premium cars, all designed for comfort and ease on long trips."
        },
        {
          question: "How do I pay for my Pune to Ajanta and Ellora cab rental?",
          answer: "We offer multiple payment options including cash, credit/debit cards, and online payment via our app, so you can choose what works best for you."
        },
        {
          question: "Can I book a round trip from Pune to Ajanta and Ellora?",
          answer: "Yes, we can arrange for a round trip. Just provide us with your return details, and we will make sure the trip is organized efficiently."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any extra charges, such as waiting time or detours, will be communicated to you upfront so that you’re always aware of the costs involved."
        },
        {
          question: "Can I hire a taxi for sightseeing in Ajanta and Ellora?",
          answer: "Yes, we offer sightseeing services in Ajanta and Ellora. Explore the ancient caves, their artwork, and the surrounding attractions with the help of our experienced drivers."
        },
        {
          question: "What is the luggage allowance for a Pune to Ajanta and Ellora taxi?",
          answer: "Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or special requests, please inform us during the booking process so we can accommodate your needs."
        },
        {
          question: "Is Morya Cab available for group travel to Ajanta and Ellora?",
          answer: "Yes, we provide group travel packages for those visiting Ajanta and Ellora, ensuring a comfortable journey for all passengers."
        },
        {
          question: "Why should I choose Morya Cab for my Pune to Ajanta and Ellora trip?",
          answer: "Morya Cab offers a reliable, safe, and comfortable journey with experienced drivers, well-maintained vehicles, and transparent pricing. We aim to make your visit to Ajanta and Ellora a memorable and enjoyable experience."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Prakash Jadhav',
          role: 'Traveler',
          review: "Our visit to Ajanta and Ellora was incredible, thanks to Morya Cab. The vehicle was very comfortable, and the driver was knowledgeable about the routes and the sites. We had a hassle-free experience, and I highly recommend their service.",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Mrs. Aarti Mehta',
          role: 'Traveler',
          review: "We booked Morya Cab for our family trip to Ajanta and Ellora, and we had an amazing experience. The vehicle was spacious, and the driver was friendly and professional. The trip was smooth and enjoyable from start to finish.",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "TaxiService",
        "name": "Pune to Ajanta Ellora Cabs",
        "description": "Book a comfortable and affordable cab or car rental for your journey from Pune to Ajanta Ellora Caves. We offer one-way, round-trip, luxury, and rental services for a seamless travel experience.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Office No. 5, First Floor, Sunshine Complex, Near ABC Chowk, Pune",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411014",
          "addressCountry": "IN"
        },
        "telephone": "+91-9371304510",
        "url": "https://moryacab.com/pune-to-ajanta-ellora-cabs",
        "logo": "https://moryacab.com/img/logo.jpg",
        "image": [
          "https://moryacab.com/img/ajanta-ellora-cabs.jpg",
          "https://moryacab.com/img/ajanta-ellora-tour.jpg"
        ],
        "priceRange": "₹5000 - ₹12000",
        "offers": {
          "@type": "Offer",
          "url": "https://moryacab.com/pune-to-ajanta-ellora-cabs",
          "priceCurrency": "INR",
          "price": 8000,
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": 4.8,
          "reviewCount": 150
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Amit Kumar"
            },
            "datePublished": "2024-10-15",
            "reviewBody": "The trip to Ajanta Ellora was incredible. The driver was professional, and the vehicle was in excellent condition. Highly recommended for anyone planning to visit these caves from Pune!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya Singh"
            },
            "datePublished": "2024-08-30",
            "reviewBody": "Great service! The journey was smooth and comfortable. The driver was knowledgeable about the spots along the way. Worth every penny!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Ajanta Ellora",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 20.5860,
            "longitude": 75.7036
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://moryacab.com/pune-to-ajanta-ellora-cabs"
        },
        "keywords": "Ajanta Ellora Caves Tour Package from Pune, Ajanta Ellora Tour from Pimpri Chinchwad, Trip to Ajanta Ellora Caves from Pune, Pune to Ajanta Ellora Cab Service, Pune to Ajanta Ellora Cab Booking, Pune to Ajanta Ellora Cab Fare, Pune to Ajanta Verul Cab Fare, Pune to Ajanta Ellora Innova Cab Fare, Pune to Ajanta Ellora Ertiga Cab, Pune to Ajanta Ellora Tempo Traveller on Rent, Pune to Ajanta Ellora Sedan Cab Service, Pune to Ajanta Ellora Mini Bus on Rent"
      };
      


    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Pune to Ajanta Ellora Cabs | Affordable & Comfortable Travel | Call: +91 9371304510</title>
  <meta
    name="description"
    content="Book a comfortable cab or car rental for your trip to Ajanta Ellora Caves from Pune. Choose from one-way, round-trip, luxury taxis, and more for a hassle-free journey."
  />
  <meta
    name="keywords"
    content="Ajanta Ellora Caves Tour Package from Pune, Ajanta Ellora Tour from Pimpri Chinchwad, Trip to Ajanta Ellora Caves from Pune, Pune to Ajanta Ellora Cab Service, Pune to Ajanta Ellora Cab Booking, Pune to Ajanta Ellora Cab Fare, Pune to Ajanta Verul Cab Fare, Pune to Ajanta Ellora Innova Cab Fare, Pune to Ajanta Ellora Ertiga Cab, Pune to Ajanta Ellora Tempo Traveller on Rent, Pune to Ajanta Ellora Sedan Cab Service, Pune to Ajanta Ellora Mini Bus on Rent"
  />
  <meta property="og:title" content="Pune to Ajanta Ellora Cabs | Morya Cabs" />
  <meta
    property="og:description"
    content="Plan your trip from Pune to Ajanta Ellora Caves with reliable, affordable, and comfortable cab services. Book your ride today!"
  />
  <meta property="og:url" content="https://moryacab.com/pune-to-ajanta-ellora-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://moryacab.com/img/ajanta-ellora-cabs.jpg" />
  <script type="application/ld+json">
    {JSON.stringify(jsonLD)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/60.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Punetoanjamtaelloracabs;